import { useEffect, useState } from "react";
import { resetAllMealsToShow } from "Redux/slices/selectedMealsSlice";
import { useDispatch } from "react-redux";
import { resetStore } from "Redux/store";
import { useAuthStatus } from "context/OAuth/AuthContext";

const BASE_URL = process.env.REACT_APP_WORDPRESS_URL;
const LOGOUT_API = `${BASE_URL}/wp-json/custom/v1/logout`;
const REDIRECT_URL = `${BASE_URL}/login`;

const Logout = () => {
  const [message, setMessage] = useState("Logging you out...");
  const [fade, setFade] = useState("opacity-100");
  const {logout } = useAuthStatus();
  const dispatch = useDispatch();
  useEffect(() => {
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const logoutUser = async () => {
      try {
        await sleep(2000);
        setMessage("Goodbye! See you soon 👋");
        setFade("opacity-0");

        await sleep(1500);
        dispatch(resetStore());
        // logout();
        const response = await fetch(LOGOUT_API, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();

        if (data.status === "success") {
          localStorage.removeItem("access_token");
          localStorage.clear();
          window.location.href = REDIRECT_URL;
        } else {
          localStorage.removeItem("access_token");
          localStorage.clear();
          console.error("Unexpected response during logout:", data);
          window.location.href = REDIRECT_URL;
        }
      } catch (error) {
        console.error("Logout failed:", error);
        localStorage.removeItem("access_token");
        localStorage.clear();
        window.location.href = REDIRECT_URL;
      }
    };

    logoutUser();
  }, []);

  return (
    <div className="h-screen flex flex-col justify-center items-center text-xl font-semibold bg-gradient-to-r from-blue-500 to-purple-500 text-white">
      <div className={`transition-opacity duration-1000 ${fade}`}>
        <p className="text-3xl font-bold animate-pulse">{message}</p>
      </div>
    </div>
  );
};

export default Logout;
